import { Image } from "react-datocms/image";
import { CodeWindow } from "./pages/CodeFeature";
import { Code } from "./Code";
import { RenderStructuredText } from "./RenderStructuredText";
import React from "react";
import { MediaViewer } from "./MediaViewer";

const Steps = ({steps}) => {
    return <>
        <div>
            {steps.map((step) => <Step key={step.id} step={step} />)}
        </div>
        <style jsx>
            {`
            div {
                margin-bottom: var(--default-vertical-spacing);
                margin-top: var(--default-vertical-spacing);
                display: flex;
                flex-direction: column;
                gap: 13px;
            }
        `}
        </style></>;
};

const Step = ({step}) => {
    return <><div className="container">
        <div className="step-container">
            <div className="step">
                {step.stepNumber}
            </div>
            <div className="vertical-line"/>
        </div>
        <div className="content">
            {step.title && <h3>{step.title}</h3>}
            <RenderStructuredText post={step}/>
        </div>
        {step?.sideImage?.responsiveImage && <div className="image"><MediaViewer><Image data={step.sideImage.responsiveImage}/></MediaViewer></div>}
        {step?.sideCode && <div className="code"><CodeWindow>
            <Code data-language={step.codeLanguage}>
                {step.sideCode}
            </Code>
        </CodeWindow></div>}
    </div>
    <style jsx>
        {`
            .step {
                background: var(--code-border);
                width: 35px;
                height: 35px;
                min-height: 35px;
                border-radius: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: var(--font-weight-bold);
                margin-top: -3px;
            }
            .image {
                border-radius: calc(var(--border-radius) * 2);
                overflow: hidden;
                border: 1px solid var(--code-border);
                width: 100%;
                height: max-content;
                margin-bottom: 1rem;
            }
            .code {
                overflow: hidden;
                width: 100%;
                height: max-content;
                margin-bottom: 1rem;
            }
            .content {
                margin-bottom: var(--default-vertical-spacing);
                width: 100%;
            }
            .content h3 {
                margin-bottom: var(--default-vertical-spacing);
            }
            .container {
                display: flex;
                gap: var(--default-vertical-spacing);
                width: calc(100vw - 400px);
                max-width: 1200px;
            }
            .vertical-line {
                height: 100%;
                border-left: 1px solid var(--code-border);
                width: 1px;
                margin-right: -1px;
            }
            .step-container {
                align-items: center;
                display: flex;
                flex-direction: column;
                gap: 10px;
            }
            @media screen and (max-width: 767px) {
                .container {
                    display: flex;
                    flex-direction: column;
                    gap: 0;
                    width: 100%;
                }
                .step-container {
                    width: 100%;
                    flex-direction: row;
                    margin-top: var(--default-vertical-spacing);
                    margin-bottom: var(--default-vertical-spacing);
                }
                .step {
                    border-bottom: 1px solid var(--code-border);
                }
                .vertical-line {
                    width: 100%;
                    border: 1px solid var(--code-border);
                }
            }
        `}
    </style>
    </>;
};

export { Steps };